export const experienceData = [
    {
        id: 1,
        company: 'Neivor',
        jobtitle: 'Front-End & Mobile Developer',
        startYear: '2022',
        endYear: '2023'
    },
    {
        id: 2,
        company: `Scaneame`,
        jobtitle: 'Data Management & Front-End Developer',
        startYear: '2022',
        endYear: '2022'
    },
    {
        id: 3,
        company: 'Henry',
        jobtitle: 'Full Stack Teaching Assistant',
        startYear: '2022',
        endYear: '2022'
    },
]